/**
 * House of Aalaya — "Watch to Cart" story player.
 *
 * Every slide is rendered server side; this only controls which one is visible
 * and keeps videos paused unless their slide is on screen.
 */
(function () {
  'use strict';

  var currentIndex = 0;

  function player() {
    return document.getElementById('ReelPlayer');
  }

  function slides() {
    var root = player();
    return root ? Array.prototype.slice.call(root.querySelectorAll('[data-reel-slide]')) : [];
  }

  function show(index) {
    var all = slides();
    if (!all.length) return;

    currentIndex = (index + all.length) % all.length;

    all.forEach(function (slide, i) {
      var active = i === currentIndex;
      slide.hidden = !active;

      var video = slide.querySelector('video');
      if (!video) return;

      if (active) {
        var play = video.play();
        if (play && play.catch) play.catch(function () { /* Autoplay blocked; the poster stays. */ });
      } else {
        video.pause();
        video.currentTime = 0;
      }
    });
  }

  function pauseAll() {
    slides().forEach(function (slide) {
      var video = slide.querySelector('video');
      if (video) video.pause();
    });
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-reel-open]');
    if (opener) {
      event.preventDefault();
      show(Number(opener.dataset.reelIndex));
      if (window.aalayaOverlay) window.aalayaOverlay.open(player());
      return;
    }

    if (event.target.closest('[data-reel-prev]')) {
      event.preventDefault();
      show(currentIndex - 1);
      return;
    }

    if (event.target.closest('[data-reel-next]')) {
      event.preventDefault();
      show(currentIndex + 1);
    }
  });

  document.addEventListener('keydown', function (event) {
    var root = player();
    if (!root || root.dataset.open !== 'true') return;

    if (event.key === 'ArrowLeft') show(currentIndex - 1);
    else if (event.key === 'ArrowRight') show(currentIndex + 1);
  });

  document.addEventListener('aalaya:overlay:closed', function (event) {
    if (event.target.id === 'ReelPlayer') pauseAll();
  });
})();
